import { totalDischargeToBeDrained } from '../conversion/discharge';
import { EUnitOfMeasure } from '../shared/enum';

export default {
    [totalDischargeToBeDrained]: {
        min: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: 0,
                [EUnitOfMeasure.Imperial]: 0,
            },
        },
        max: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: undefined,
                [EUnitOfMeasure.Imperial]: undefined,
            },
        },
    },
};
